import * as yup from 'yup';
import { requiredMsg } from '../../../../../../../utils/validationMessages';

export const ObjectiveSchema = yup.object().shape({
  name: yup.string().required(requiredMsg('Name')),
  frequency: yup.string().required(requiredMsg('Frequency')),
});
